import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface AdminStats {
  pendingClaims: number;
  totalFeedback: number;
  activeUsers: number;
  loading: boolean;
  error: string | null;
}

export const useAdminStats = () => {
  const [stats, setStats] = useState<AdminStats>({
    pendingClaims: 0,
    totalFeedback: 0,
    activeUsers: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { count: pendingCount, error: pendingError } = await supabase
          .from('api_athlete_claim_requests')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'pending');

        if (pendingError) throw pendingError;

        const { count: feedbackCount, error: feedbackError } = await supabase
          .from('feedback')
          .select('*', { count: 'exact', head: true });

        if (feedbackError) throw feedbackError;

        const { count: activeCount, error: activeError } = await supabase
          .from('profiles')
          .select('*', { count: 'exact', head: true })
          .eq('beta_access', true);

        if (activeError) throw activeError;

        setStats({
          pendingClaims: pendingCount || 0,
          totalFeedback: feedbackCount || 0,
          activeUsers: activeCount || 0,
          loading: false,
          error: null,
        });
      } catch (error) {
        console.error('Error fetching admin stats:', error);
        setStats(prev => ({
          ...prev,
          loading: false,
          error: error instanceof Error ? error.message : 'Failed to load stats',
        }));
      }
    };

    fetchStats();
  }, []);

  return stats;
};
